<template>
  <v-container>
    <v-responsive class="overflow-y-auto" max-height="600">
      <v-carousel
        cycle
        height="1800"
        interval="6000"
        hide-delimiter-background
        show-arrows-on-hover
      >
        <v-carousel-item light v-for="(article, i) in articles" :key="i">
          <v-sheet height="20%">
            <v-row align="center" justify="center">
              <div class="display-1">{{ article.Heading }}</div>
            </v-row>
            <v-row align="center" justify="center">
              <v-img height="400px" contain :src="imageSource(i)"></v-img>
            </v-row>
            <v-row class="pa-15">
              <div v-html="article.Article"></div>
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </v-responsive>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      colors: [
        "indigo",
        "warning",
        "pink darken-2",
        "red lighten-1",
        "deep-purple accent-4",
      ],
      articles: [],
    };
  },
  created() {
    this.GetArticles();
  },
  methods: {
    GetArticles() {
      // Get Articles EndPoint
      const baseURL = "https://ownurgoal.net.au:4100/articles/";
      axios
        .get(baseURL)
        .then((response) => {
          this.articles = response.data.result;
        })
        .catch((error) => {
          console.log(error);
          this.error =
            "Error Retrieving Articles - please check details and try again";
        });
    },
    imageSource(ele) {
      let src =
        "https://admin.ownurgoal.net.au/_lib/file/imgArticles/" +
        this.articles[ele].Image;
      return src;
    },
  },
  computed: {},
};
</script>
